import React from 'react';
import './FilterBar.css';

function FilterBar({
  selectedStatus,
  setSelectedStatus,
  selectedDepartment,
  setSelectedDepartment,
  onClear,
  searchKeyword,
  setSearchKeyword,
  sortBy,
  setSortBy
}) {
  return (
    <div className="filter-bar">
      <input
        type="text"
        placeholder="🔍 Search by keyword"
        value={searchKeyword}
        onChange={(e) => setSearchKeyword(e.target.value)}
      />

      <select value={selectedStatus} onChange={(e) => setSelectedStatus(e.target.value)}>
        <option value="">All Status</option>
        <option value="Active">✅ Active</option>
        <option value="Expired">❌ Expired</option>
      </select>

      <select value={selectedDepartment} onChange={(e) => setSelectedDepartment(e.target.value)}>
        <option value="">All Departments</option>
        <option value="DRDO">DRDO</option>
        <option value="Education">Education</option>
        <option value="Health & Welfare">Health & Welfare</option>
        <option value="IT Ministry">IT Ministry</option>
      </select>

      <select value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
        <option value="">Sort By</option>
        <option value="postedDate">📅 Posted Date</option>
        <option value="title">🔠 Title</option>
        <option value="lastDate">📌 Last Date</option>
      </select>

      <button onClick={onClear}>Clear Filters</button>
    </div>
  );
}

export default FilterBar;
